<template>
  <e-charts
      ref="line"
      autoresize
      :options="option"
      theme="theme-color"
      auto-resize
      @click="(e)=>$emit('click', e)"
  />
</template>

<script>

import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import 'echarts/lib/chart/pie';
import { TheChartMixin } from './theme';

export default {
  mixins: [
    TheChartMixin
  ],
  props: {
    series: {
      type: Array,
      default: null
    },
    showLegend: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      option: {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          show: this.showLegend,
          left: 10,
          bottom: '0'
        },
        series: this.series
      }
    };
  },
  watch: {
    series: {
      deep: true,
      handler(val) {
        this.option = { ...this.option, series: val };
      }
    },
    showLegend(val) {
      this.option = { ...this.option, legend: { ...this.option.legend, show: val } };
    }
  },
  handleClick(event) {
    console.log('handleClick', event);
  }
};
</script>
